import { useContext } from 'react';

import { LayoutPreferenceContext } from './LayoutPreferenceContext';

export const useLayoutPreference = () => {
  const context = useContext(LayoutPreferenceContext);
  if (!context) {
    throw new Error(
      'useLayoutPreference must be used within LayoutPreferenceProvider',
    );
  }
  return context;
};
